import { Box, Link, Typography } from '@mui/material'
import { DashboardData } from 'store/dashboard/types'
import SectionCard from '../SectionCard'
import { capitaliseFirstLetter } from 'utils'
import StatusChip from 'containers/dashboard/dashboardPage/components/recentCompanySearchesCard/StatusChip'

type Props = {
  dashboardData: DashboardData | null
}

function RecentCompanySearchesCard({ dashboardData }: Props) {
  return (
    <SectionCard title="Recent company searches">
      {dashboardData?.companySearches.recentSearches.slice(0, 5).map((company, index) => {
        const content = (
          <>
            <Typography
              variant="body2"
              noWrap
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%',
                color: 'black',
              }}>
              {capitaliseFirstLetter(company.name.split('||||')[0])}
            </Typography>
            <StatusChip status={company.status} multisectorId={company.multisector_id} />
          </>
        )

        const wrapperStyles = {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 0.5,
          px: 1,
          borderRadius: 1,
        }

        return company.status === 'searches_finished' ? (
          <Link
            key={company.id}
            href={`/dashboard/reporting/company/${company.multisector_id}`}
            underline="none"
            sx={{
              ...wrapperStyles,
              '&:hover': {
                bgcolor: '#f5f5f5',
              },
            }}>
            {content}
          </Link>
        ) : (
          <Box key={company.id} sx={wrapperStyles}>
            {content}
          </Box>
        )
      })}
    </SectionCard>
  )
}

export default RecentCompanySearchesCard
